export interface RequestInitExt extends RequestInit {
  description?: string;
}

async function fetchInternal<T>(
  input: RequestInfo,
  init: RequestInitExt,
  handler: (response: Response) => Promise<T>,
) {
  const { description = 'fetch', ...fetchInit } = init;

  let response;
  try {
    response = await fetch(input, fetchInit);
  } catch (error) {
    if (!error) {
      error = new Error();
    }
    error.message = `Failed to ${description}: ${error.message}`;
    throw error;
  }

  if (response.ok) {
    try {
      return await handler(response);
    } catch (error) {
      if (!error) {
        error = new Error();
      }
      error.message = `Failed to ${description}: ${error.message}`;
      throw error;
    }
  } else {
    throw new Error(`Failed to ${description}: ${response.status} - ${response.statusText}`);
  }
}

export async function fetchJSON<T>(input: RequestInfo, init: RequestInitExt = {}) {
  return fetchInternal<T>(input, init, response => response.json());
}

export async function fetchText(input: RequestInfo, init: RequestInitExt = {}) {
  return fetchInternal<string>(input, init, response => response.text());
}
